
<template>
  <section
    class="ColorPicker"
    :style="{ '--height': height, '--width': width }"
  >
    <A
      v-for="color in colors"
      :key="color"
      :style="{ '--clr': color }"
      :class="['color', color]"
      @click="onColorPick(color)"
    ></A>
  </section>
</template>

<script>
export default {
  props: ["height", "width", "onColorPick"],
  data() {
    return {
      colors: [
        "rgb(249, 235, 234)",
        "rgb(242, 215, 213)",
        "rgb(230, 176, 170)",
        "rgb(217, 136, 128)",
        "rgb(205, 97, 85)",
        "rgb(192, 57, 43)",
        "rgb(169, 50, 38)",
        "rgb(146, 43, 33)",
        "rgb(123, 36, 28)",
        "rgb(100, 30, 22)",
        "rgb(253, 237, 236)",
        "rgb(250, 219, 216)",
        "rgb(245, 183, 177)",
        "rgb(241, 148, 138)",
        "rgb(236, 112, 99)",
        "rgb(231, 76, 60)",
        "rgb(203, 67, 53)",
        "rgb(176, 58, 46)",
        "rgb(148, 49, 38)",
        "rgb(120, 40, 31)",
        "rgb(245, 238, 248)",
        "rgb(235, 222, 240)",
        "rgb(215, 189, 226)",
        "rgb(195, 155, 211)",
        "rgb(175, 122, 197)",
        "rgb(155, 89, 182)",
        "rgb(136, 78, 160)",
        "rgb(118, 68, 138)",
        "rgb(99, 57, 116)",
        "rgb(81, 46, 95)",
        "rgb(244, 236, 247)",
        "rgb(232, 218, 239)",
        "rgb(210, 180, 222)",
        "rgb(187, 143, 206)",
        "rgb(165, 105, 189)",
        "rgb(142, 68, 173)",
        "rgb(125, 60, 152)",
        "rgb(108, 52, 131)",
        "rgb(91, 44, 111)",
        "rgb(74, 35, 90)",
        "rgb(234, 242, 248)",
        "rgb(212, 230, 241)",
        "rgb(169, 204, 227)",
        "rgb(127, 179, 213)",
        "rgb(84, 153, 199)",
        "rgb(41, 128, 185)",
        "rgb(36, 113, 163)",
        "rgb(31, 97, 141)",
        "rgb(26, 82, 118)",
        "rgb(21, 67, 96)",
        "rgb(235, 245, 251)",
        "rgb(214, 234, 248)",
        "rgb(174, 214, 241)",
        "rgb(133, 193, 233)",
        "rgb(93, 173, 226)",
        "rgb(52, 152, 219)",
        "rgb(46, 134, 193)",
        "rgb(40, 116, 166)",
        "rgb(33, 97, 140)",
        "rgb(27, 79, 114)",
        "rgb(232, 248, 245)",
        "rgb(209, 242, 235)",
        "rgb(163, 228, 215)",
        "rgb(118, 215, 196)",
        "rgb(72, 201, 176)",
        "rgb(26, 188, 156)",
        "rgb(23, 165, 137)",
        "rgb(20, 143, 119)",
        "rgb(17, 120, 100)",
        "rgb(14, 98, 81)",
        "rgb(232, 246, 243)",
        "rgb(208, 236, 231)",
        "rgb(162, 217, 206)",
        "rgb(115, 198, 182)",
        "rgb(69, 179, 157)",
        "rgb(22, 160, 133)",
        "rgb(19, 141, 117)",
        "rgb(17, 122, 101)",
        "rgb(14, 102, 85)",
        "rgb(11, 83, 69)",
        "rgb(233, 247, 239)",
        "rgb(212, 239, 223)",
        "rgb(169, 223, 191)",
        "rgb(125, 206, 160)",
        "rgb(82, 190, 128)",
        "rgb(39, 174, 96)",
        "rgb(34, 153, 84)",
        "rgb(30, 132, 73)",
        "rgb(25, 111, 61)",
        "rgb(20, 90, 50)",
        "rgb(234, 250, 241)",
        "rgb(213, 245, 227)",
        "rgb(171, 235, 198)",
        "rgb(130, 224, 170)",
        "rgb(88, 214, 141)",
        "rgb(46, 204, 113)",
        "rgb(40, 180, 99)",
        "rgb(35, 155, 86)",
        "rgb(29, 131, 72)",
        "rgb(24, 106, 59)",
        "rgb(254, 249, 231)",
        "rgb(252, 243, 207)",
        "rgb(249, 231, 159)",
        "rgb(247, 220, 111)",
        "rgb(244, 208, 63)",
        "rgb(241, 196, 15)",
        "rgb(212, 172, 13)",
        "rgb(183, 149, 11)",
        "rgb(154, 125, 10)",
        "rgb(125, 102, 8)",
        "rgb(254, 245, 231)",
        "rgb(253, 235, 208)",
        "rgb(250, 215, 160)",
        "rgb(248, 196, 113)",
        "rgb(245, 176, 65)",
        "rgb(243, 156, 18)",
        "rgb(214, 137, 16)",
        "rgb(185, 119, 14)",
        "rgb(156, 100, 12)",
        "rgb(126, 81, 9)",
        "rgb(253, 242, 233)",
        "rgb(250, 229, 211)",
        "rgb(245, 203, 167)",
        "rgb(240, 178, 122)",
        "rgb(235, 152, 78)",
        "rgb(230, 126, 34)",
        "rgb(202, 111, 30)",
        "rgb(175, 96, 26)",
        "rgb(147, 81, 22)",
        "rgb(120, 66, 18)",
        "rgb(251, 238, 230)",
        "rgb(246, 221, 204)",
        "rgb(237, 187, 153)",
        "rgb(229, 152, 102)",
        "rgb(220, 118, 51)",
        "rgb(211, 84, 0)",
        "rgb(186, 74, 0)",
        "rgb(160, 64, 0)",
        "rgb(135, 54, 0)",
        "rgb(110, 44, 0)",
        "rgb(253, 254, 254)",
        "rgb(251, 252, 252)",
        "rgb(247, 249, 249)",
        "rgb(244, 246, 247)",
        "rgb(240, 243, 244)",
        "rgb(236, 240, 241)",
        "rgb(208, 211, 212)",
        "rgb(179, 182, 183)",
        "rgb(151, 154, 154)",
        "rgb(123, 125, 125)",
        "rgb(248, 249, 249)",
        "rgb(242, 243, 244)",
        "rgb(229, 231, 233)",
        "rgb(215, 219, 221)",
        "rgb(202, 207, 210)",
        "rgb(189, 195, 199)",
        "rgb(166, 172, 175)",
        "rgb(144, 148, 151)",
        "rgb(121, 125, 127)",
        "rgb(98, 101, 103)",
        "rgb(244, 246, 246)",
        "rgb(234, 237, 237)",
        "rgb(213, 219, 219)",
        "rgb(191, 201, 202)",
        "rgb(170, 183, 184)",
        "rgb(149, 165, 166)",
        "rgb(131, 145, 146)",
        "rgb(113, 125, 126)",
        "rgb(95, 106, 106)",
        "rgb(77, 86, 86)",
        "rgb(242, 244, 244)",
        "rgb(229, 232, 232)",
        "rgb(204, 209, 209)",
        "rgb(178, 186, 187)",
        "rgb(153, 163, 164)",
        "rgb(127, 140, 141)",
        "rgb(112, 123, 124)",
        "rgb(97, 106, 107)",
        "rgb(81, 90, 90)",
        "rgb(66, 73, 73)",
        "rgb(235, 237, 239)",
        "rgb(214, 219, 223)",
        "rgb(174, 182, 191)",
        "rgb(133, 146, 158)",
        "rgb(93, 109, 126)",
        "rgb(52, 73, 94)",
        "rgb(46, 64, 83)",
        "rgb(40, 55, 71)",
        "rgb(33, 47, 60)",
        "rgb(27, 38, 49)",
        "rgb(234, 236, 238)",
        "rgb(213, 216, 220)",
        "rgb(171, 178, 185)",
        "rgb(128, 139, 150)",
        "rgb(86, 101, 115)",
        "rgb(44, 62, 80)",
        "rgb(39, 55, 70)",
        "rgb(33, 47, 61)",
        "rgb(28, 40, 51)",
        "rgb(23, 32, 42)",
        "rgb(255, 255, 255)",
        "rgb(0, 0, 0)",
        "transparent",
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.ColorPicker {
  padding: 10rem;
  width: var(--width);
  height: var(--height);
  display: grid;
  grid-template-rows: repeat(10, 1fr);
  grid-gap: 0.5rem;
  grid-auto-flow: column;
  .color {
    border-radius: 100%;
    height: 0;
    padding-bottom: 100%;
    background-color: var(--clr);
    border: 1px solid var(--clrFaded);
    &.transparent {
		border-style: dashed;
    }
  }
}
</style>
